import { useMemo, useRef } from 'react'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES } from 'constants/search'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import useConsumePendingSelectDatesPrompt from 'hooks/GlobalSearch/useConsumePendingSelectDatesPrompt'
import useSearchVerticalLabels from 'hooks/GlobalSearch/useSearchVerticalLabels'
import HotelsTabContent from '../Components/Mobile/TabContents/HotelsTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'

function useGlobalSearchVerticalTabHotels(): App.GlobalSearchVerticalTabV2 {
  const queryParams = useQueryParams()
  const {
    globalHotelsSearchDispatch,
    globalHotelsSearchState,
  } = useGlobalHotelsSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  useConsumePendingSelectDatesPrompt(globalHotelsSearchDispatch, 'hotels')

  const temporarySearchSubmitRef = useRef<App.TypeaheadSubmitRefData | null>(null)

  const {
    onSearch,
    context,
    updateSearchSessionId,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHotelsSearchDispatch,
    globalSearchState: globalHotelsSearchState,
    temporarySearchSubmitRef,
    enableTypeaheadSubmit: true,
    typeaheadTypes: HOTEL_SEARCH_TYPEAHEAD_TYPES,
  })

  const verticalLabels = useSearchVerticalLabels()

  return useMemo((): App.GlobalSearchVerticalTabV2 => {
    return {
      label: verticalLabels.hotels,
      key: 'hotels',
      context,
      onSearch,
      ContentComponent: HotelsTabContent,
      Icon: LineBedIcon,
      updateSearchSessionId,
      temporarySearchSubmitRef,
    }
  }, [context, onSearch, updateSearchSessionId, verticalLabels])
}

export default useGlobalSearchVerticalTabHotels
